import { render, staticRenderFns } from "./uploaderList.vue?vue&type=template&id=4058baf7&scoped=true&"
import script from "./uploaderList.vue?vue&type=script&lang=js&"
export * from "./uploaderList.vue?vue&type=script&lang=js&"
import style0 from "./uploaderList.vue?vue&type=style&index=0&id=4058baf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4058baf7",
  null
  
)

export default component.exports